<template lang="html">
	<div class="omapi-card__flex campaign-type-selector" @keydown.esc="clearFilters">
		<templates-type-card
			v-for="(typeLabel, type) in typeNames"
			:key="type"
			:size="typeCount"
			:class="cardClass(type)"
			:type="type"
			:type-label="typeLabel"
		/>
	</div>
</template>

<script lang="js">
import get from 'lodash/get'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters } = createNamespacedHelpers('templates')

export default {
	/**
	 * Called when the route that renders this component is about to be
	 * navigated away from.
	 *
	 * @since  2.0.0
	 *
	 * @param  {Object}   to   New route.
	 * @param  {Object}   from Old route.
	 * @param  {Function} next Tells Vue Router we can proceed.
	 *
	 * @returns {void}
	 */
	beforeRouteLeave (to, from, next) {
		if ('templates' !== get(to, 'meta.parent') && 'templates' !== get(to, 'name')) {
			// If going away from templates, need to reset the type.
			this.setActiveType('popup')
		}
		next()
	},
	computed : {
		...mapState([ 'activeType' ]),
		...mapGetters([ 'typeNames', 'typeCount' ]),
	},
	watch : {
		$route (to) {
			this.setActiveType(get(to, 'params.type', 'popup'))
		},
	},
	mounted () {
		this.setActiveType(this.$get('$route.params.type', this.activeType))
	},
	methods : {
		cardClass (type) {
			return type === this.activeType ? 'selected' : ''
		},
		setActiveType (type) {
			this.$store.dispatch('templates/goToFilteredView', { type, push: false })
		},
	},
};
</script>
<style lang="scss">
@import '../../assets/scss/variables';
.campaign-type-selector {
	align-items: center;
	margin: 0 -8px 33px;
	justify-content: flex-start;

	.omapi-card {
		align-items: center;
		margin: 8px;
		flex-grow: 1;
		justify-content: center;
		cursor: pointer;
		box-sizing: border-box;
		height: 161px;

		&.selected,
		&:hover {
			position: relative;
			border: 2px solid $color_blue-primary;
		}
		&.selected {
			&:before {
				content: url('../../assets/images/icons/green-success-circle.svg');
				position: absolute;
				top: 8px;
				right: 8px;
				width: 21px;
				height: 21px;
			}
		}

		&__half {
			max-width: calc(50% - 16px);
		}
		&__third {
			max-width: calc(33.333333333% - 16px);
		}
		&__fourth {
			max-width: calc(25% - 16px);
			@media screen and (max-width: 580px) {
				max-width: 160px;
			}
		}
		&__fifth {
			max-width: calc(20% - 16px);
			@media screen and (max-width: 1000px) {
				max-width: 160px;
			}
		}
		&__sixth {
			max-width: calc(16.66666666% - 16px);
			@media screen and (max-width: 1024px) {
				max-width: calc(33.3333333% - 16px);
				flex-basis: 33%;
			}
		}

		.omapi-card-content {
			cursor: pointer;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 0;
			h5 {
				font-size: 15px;
				font-weight: $font_bold;
				padding-top: 3px;
				margin: 0;
			}
		}
	}
}
</style>
